//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export class PostMessageListener<T> {
  private messageHandler?: (arg0: MessageEvent) => void;
  private readonly listeners: ((arg0: T, arg1: MessageEvent) => void)[] = [];

  constructor(
    private readonly target: Window,
    private readonly origin: string,
    private readonly messageFilter: (message: unknown) => T | undefined,
  ) {}

  public attach(): void {
    if (!this.messageHandler) {
      this.messageHandler = (event: MessageEvent) => {
        if (this.origin !== '*' && event.origin !== this.origin) {
          return;
        }
        const filtered = this.messageFilter(event.data);
        if (typeof filtered !== 'undefined') {
          this.emitMessage(filtered, event);
        }
      };
      this.target.addEventListener('message', this.messageHandler);
    }
  }

  public detach(): void {
    if (this.messageHandler) {
      this.target.removeEventListener('message', this.messageHandler);
    }
  }

  public onMessage(listener: (arg0: T, arg1: MessageEvent) => void): void {
    this.listeners.push(listener);
  }

  private emitMessage(message: T, event: MessageEvent): void {
    this.listeners.forEach((listener) => listener(message, event));
  }
}
